module.exports = __webpack_public_path__ + "payment_payment_system.68629aa11c7ff820178a05973dbef6d3.png";